const { protocol, host } = window.location

export const addProtocolAndHost = path => {
  return `${protocol}//${host}/${path}`
}
